<template>
    <Card :bordered='false' class='border-radius-0'>
        <CTable
                v-if="data.searchLabType"
                :ref="e => { if (!refs.table) { onTableMounted({ e }) } }"
                :isLoading='isLoading'
                v-model:columns='state.columns'
                v-model:page='state.page'
                :options='state.tableOptions'
                :manages='state.manages'
                :manageExtras='state.manageExtras'
                :rowActions='state.rowActions'
                @search='(search) => onSearch({...search, props})'
                :visibleSearch='checkAllVisibleSearch'
        ></CTable>
    </Card>
</template>

<script>
    import { defineAsyncComponent, defineComponent, reactive } from "vue";
    import { useRoute } from "vue-router";
    import { initState, isLoading, onSearch, state } from "./topic-list.logic";
    import { Card } from "ant-design-vue";
    import { matchMenu } from "../../../../../utils/menu-context";
    import { state as stateApp } from "../../../../../app.logic";

    export default defineComponent({
        components: {
            Card,
            CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable"))
        },
        props: {
            menuContext: { default: () => matchMenu("/app/master-mgt/lab/topics", stateApp.authInfo.menus) },
            disabledSearch: { default: () => [] },
            visibleSearch: { default: true },
        },
        setup(props) {
            const route = useRoute();
            const isForceDisabledCreate = route?.query?.isForceDisabledCreate == 'true' ? true: false;
            const isForceInvisibleSearch = route?.query?.isForceInvisibleSearch == 'true' ? true: false;
            const checkAllVisibleSearch = props.visibleSearch && !isForceInvisibleSearch;
            const data = reactive({ labTopicUnitGroups: [], searchLabType: null, isForceDisabledCreate: isForceDisabledCreate });
            const refs = reactive({ table: null });

            const onTableMounted = ({ e }) => {
                refs.table = e
                window.onMounted?.({ props, data, refs, isLoading })
            }
            initState({ props, data });
            return { isLoading, state, onSearch, props, refs, data, onTableMounted, checkAllVisibleSearch };
        }
    });
</script>

